module.exports = __webpack_public_path__ + "static/media/top-arrow-restaurant.5549b9e1.svg";